import React from "react";
import { useState, useEffect } from "react";
import { useContext } from "react";
import { MyContext } from "../../context/UserProvider";
import { useNavigate } from "react-router-dom";
//------------------------------------------------------
//importações dos componentes Filho

//Fim das importações dos componentes Filho
//------------------------------------------------------


//inicio Importe dos icones 
import { FaRegEdit, FaCheck, FaTimes, FaPlus, FaRegTrashAlt, FaArrowLeft } from "react-icons/fa";
//fim Importe dos icones




export default function UserPageLayout({ }) {
    const navigate = useNavigate();
    //Identificador de mobile
    const [windowDimensions, setWindowDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });
    const isMobile = windowDimensions.width < 696;
    //fim do identificador de mobile

    //----------------------------------------------------------------

    //Inicio das variáveis de globais
    const {
        setLogin,
        setScrollY,
        showOrcamento,
        setShowOrcamento,
        setShowUser,
        usuario,
        setUsuario,
        showLayoutMeusDados,
        setShowLayoutMeusDados,
        showLayoutEndereco,
        setShowLayoutEndereco,
        showLayoutNewEndereco,
        setShowLayoutNewEndereco,
        showLayoutEditEndereco,
        setShowLayoutEditEndereco,
        showPedidos, setShowPedidos,
        showConfirmationDelete,
        setShowConfirmationDelete,
    } = useContext(MyContext);
    //Fim das variáveis globais
    return (
        <div
            style={{
                marginTop: 0,
                display: "flex",
                gap: isMobile ? 8 : 0,
                flexDirection: isMobile ? "column" : "row",
                width: isMobile
                    ? "100%"
                    : showLayoutMeusDados ||
                        showLayoutEndereco ||
                        showLayoutNewEndereco ||
                        showLayoutEditEndereco
                        ? "90%"
                        : "100%",
                        height: "100%",
            }}
        >
            <aside
                style={{
                    borderRadius: isMobile ? 0 : 12,
                    padding: isMobile ? "0.4rem" : "0.4rem", // Reduced padding for sidebar
                    background: "#ffffff",
                    border: windowDimensions.width < 686 ? "none" : "1px solid #e6e9ee",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",

                    width: isMobile ? "100%" : "100%",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    <button
                        onClick={() => {
                            setShowLayoutEditEndereco(false);
                            setShowLayoutNewEndereco(false);
                            setShowLayoutEndereco(false);
                            setShowPedidos(false);
                            setShowLayoutMeusDados(true);
                        }}
                        aria-pressed={showLayoutMeusDados}
                        style={{
                            padding: "0.6rem",
                            borderRadius: '5px',
                            textAlign: "left",
                            border: "none",
                            background: showLayoutMeusDados ? "#111827" : "#00000010",
                            color: showLayoutMeusDados ? "#fff" : "#111827",
                            cursor: "pointer",
                        }}
                    >
                        Meus dados
                    </button>
                    <button
                        onClick={() => {
                            // ativa a flag de orçamento no contexto
                            setShowOrcamento(true);
                            setShowUser(false);
                            setShowLayoutMeusDados(false);
                            setShowLayoutEndereco(false);
                            setShowLayoutNewEndereco(false);
                            setShowLayoutEditEndereco(false);
                            setShowPedidos(false);

                            setShowConfirmationDelete(false);
                        }}
                        aria-pressed={!!showOrcamento}
                        style={{
                            padding: "0.6rem",
                            borderRadius: '5px',
                            textAlign: "left",
                            border: "none",
                            background: showOrcamento ? "#111827" : "#00000010",
                            color: showOrcamento ? "#fff" : "#111827",
                            cursor: "pointer",
                        }}
                    >
                        Meu orçamento
                    </button>
                    <button
                        onClick={() => {
                            // ativa a flag de orçamento no contexto

                            setShowPedidos(true)
                            setShowOrcamento(false);
                            setShowLayoutMeusDados(false);
                            setShowLayoutEndereco(false);
                            setShowLayoutNewEndereco(false);
                            setShowLayoutEditEndereco(false);
                            setShowConfirmationDelete(false);
                        }}
                        aria-pressed={!!showOrcamento}
                        style={{
                            padding: "0.6rem",
                            borderRadius: '5px',
                            textAlign: "left",
                            border: "none",
                            background: showOrcamento ? "#111827" : "#00000010",
                            color: showOrcamento ? "#fff" : "#111827",
                            cursor: "pointer",
                        }}
                    >
                        Meus pedidos
                    </button>

                    <button
                        onClick={() => {

                            setShowPedidos(false)
                            setShowOrcamento(false);
                            setShowLayoutMeusDados(false);
                            setShowLayoutNewEndereco(false);
                            setShowLayoutEditEndereco(false);
                            setShowConfirmationDelete(false);
                            setShowLayoutEndereco(true);
                        }}
                        aria-pressed={showLayoutEndereco}
                        style={{
                            padding: "0.6rem",
                            borderRadius: '5px',
                            textAlign: "left",
                            border: "none",
                            background: showLayoutEndereco ? "#111827" : "#00000010",
                            color: showLayoutEndereco ? "#fff" : "#111827",
                            cursor: "pointer",
                        }}
                    >
                        Endereço de entrega
                    </button>


                    <button
                        type="button"
                        onClick={() => {
                            localStorage.removeItem("usuario");
                            setLogin?.(false);
                            navigate("/");
                        }}
                        aria-label="Sair da Conta"
                        style={{
                            padding: "0.65rem 0.9rem",
                            borderRadius: 10,
                            border: "none",
                            background: "#facc15",
                            color: "#111827",
                            boxShadow: "0 6px 18px rgba(17,24,39,0.08)",
                            cursor: "pointer",
                            zIndex: 10001, // acima de overlays
                        }}
                    >
                        Sair da Conta
                    </button>
                </div>
            </aside>
        </div>);
}